import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Include helper methods for API calls
import {
  getPhases as getPhasesApi,
  addNewPhase as addNewPhaseApi,
  updatePhase as updatePhaseApi,
  deletePhase as deletePhaseApi,
  getPhaseById as getPhaseByIdApi,
  getPhaseBlockById as getPhaseBlockByIdApi,
} from "../../helpers/fakebackend_helper";

// Fetch Phases
export const getPhases = createAsyncThunk("phases", async () => {
  try {
    const response = await getPhasesApi();
    return response;
  } catch (error) {
    toast.error("Failed to fetch phases", { autoClose: 1000 });
    throw error;
  }
});

// Fetch Phase by ID
export const getPhaseById = createAsyncThunk(
  "phases/getPhaseById",
  async (id) => {
    try {
      const response = await getPhaseByIdApi(id); // New API call to get a single phase by ID
      return response;
    } catch (error) {
      toast.error("Failed to fetch phase by ID", { autoClose: 1000 });
      throw error;
    }
  }
);

// Fetch Phase by ID
export const getPhaseBlockById = createAsyncThunk(
  "phases/getPhaseBlockById",
  async (id) => {
    try {
      const response = await getPhaseBlockByIdApi(id); // New API call to get a single phase by ID
      return response;
    } catch (error) {
      toast.error("Failed to fetch phase by ID", { autoClose: 1000 });
      throw error;
    }
  }
);

// Add New Phase
export const addNewPhase = createAsyncThunk(
  "phases/addNewPhase",
  async (phase) => {
    try {
      const response = await addNewPhaseApi(phase);
      toast.success("Phase Added Successfully", { autoClose: 1000 });
      return response;
    } catch (error) {
      toast.error("Failed to add phase", { autoClose: 1000 });
      throw error;
    }
  }
);

// Update Phase
export const updatePhase = createAsyncThunk(
  "phases/updatePhase",
  async (phase) => {
    try {
      const response = await updatePhaseApi(phase);
      toast.success("Phase Updated Successfully", { autoClose: 1000 });
      return response;
    } catch (error) {
      toast.error("Failed to update phase", { autoClose: 1000 });
      throw error;
    }
  }
);

// Delete Phase
export const deletePhase = createAsyncThunk(
  "phases/deletePhase",
  async (phaseId) => {
    try {
      const response = await deletePhaseApi(phaseId);
      toast.success("Phase Deleted Successfully", { autoClose: 1000 });
      return { phaseId, ...response };
    } catch (error) {
      toast.error("Failed to delete phase", { autoClose: 1000 });
      throw error;
    }
  }
);
